import type { IToast } from '@components/molecules/toast'
import type { SetupIntent, PaymentIntent } from '@stripe/stripe-js'


export enum GroupActions {
    SET_TOAST = 'SET_TOAST',

    RESET_GROUP_STATE = 'RESET_GROUP_STATE',

    SET_CREATE_REQUEST_BODY = 'SET_CREATE_REQUEST_BODY',
    UPDATE_CREATE_REQUEST_BODY = 'UPDATE_CREATE_REQUEST_BODY',

    SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD',
    ADD_SETUP_INTENT = 'ADD_SETUP_INTENT',
    ADD_PAYMENT_INTENT = 'ADD_PAYMENT_INTENT',
    SET_PLEDGE_AMOUNT = 'SET_PLEDGE_AMOUNT',
    SET_USE_CREDIT_BALANCE = 'SET_USE_CREDIT_BALANCE',

    SET_REMOVE_PLEDGE = 'SET_REMOVE_PLEDGE',

    SET_EDITING_PARTICIPANT = 'SET_EDITING_PARTICIPANT',
}


interface SetToast {
    type: typeof GroupActions.SET_TOAST
    payload: IToast
}

interface ResetGroupState {
    type: typeof GroupActions.RESET_GROUP_STATE
}

interface SetCreateRequestBody {
    type: typeof GroupActions.SET_CREATE_REQUEST_BODY
    payload: CreateGroupRequestBody | undefined
}
interface UpdateCreateRequestBody {
    type: typeof GroupActions.UPDATE_CREATE_REQUEST_BODY
    payload: Partial<CreateGroupRequestBody>
}

interface AddPaymentMethod {
    type: typeof GroupActions.SET_PAYMENT_METHOD
    payload: CreditCard | ApplePay | GooglePay | undefined
}
interface AddSetupIntent {
    type: typeof GroupActions.ADD_SETUP_INTENT
    payload: SetupIntent
}
interface AddPaymentIntent {
    type: typeof GroupActions.ADD_PAYMENT_INTENT
    payload: PaymentIntent
}
interface SetPledgeAmount {
    type: typeof GroupActions.SET_PLEDGE_AMOUNT
    payload: number | undefined
}
interface SetUseCreditBalance {
    type: typeof GroupActions.SET_USE_CREDIT_BALANCE
    payload: boolean | undefined
}

interface SetRemovePledge {
    type: typeof GroupActions.SET_REMOVE_PLEDGE
    payload: string | undefined
}

interface SetEditingParticipant {
    type: typeof GroupActions.SET_EDITING_PARTICIPANT
    payload: boolean
}

export type GroupActionTypes = (
    SetToast |

    ResetGroupState |

    SetCreateRequestBody |
    UpdateCreateRequestBody |

    AddPaymentMethod |
    AddSetupIntent |
    AddPaymentIntent |
    SetPledgeAmount |
    SetUseCreditBalance |

    SetRemovePledge |

    SetEditingParticipant
)
